<template>
    <div class="slider-item">
        <h3 ref="title" class="slider-item__title">{{ question }}</h3>
    </div>
</template>
<script>
import anime from 'animejs';

export default {
    name: 'QuestionSlide',
    props: {
        question: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                anime({
                    targets: this.$refs.title,
                    translateY: [40, 0],
                    opacity: [0, 1],
                    delay: 300,
                });
            } else {
                this.$refs.title.removeAttribute('style');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &__title {
        background: linear-gradient(180deg, #f5f7ff 0%, #af6dd3 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        text-fill-color: transparent;
        font-family: Patron, sans-serif;
        font-size: 48px;
        font-weight: 400;
        margin: 0;
    }
}
</style>
